<template>
  <div>
    <titulo-historico-escolar />

    <b-row>
      <b-col md="4">
        <input-text
          ref="nome"
          v-model="nome"
          label="FINANCEIRO.BUSCAR_NOME_CODIGO_MATRICULA"
          placeholder="GERAL.DIGITE_OU_PROCURE"
          @enter="getMatriculas"
        />
      </b-col>
      <b-col md="auto">
        <b-button
          variant="primary"
          class="botao-acao-filtro mb-3 w-100"
          @click="pesquisar"
        >
          {{ $t('GERAL.BUSCAR') }}
        </b-button>
      </b-col>
      <b-col md="auto">
        <b-button
          variant="secondary"
          class="botao-acao-filtro mb-3 w-100"
          @click="limpar"
        >
          {{ $t('GERAL.LIMPAR_PESQUISA') }}
        </b-button>
      </b-col>
    </b-row>

    <b-row class="mt-3">
      <b-col>
        <h5 class="mb-2">
          Imprimir Histórico escolar ou Certificado de conclusão
        </h5>
      </b-col>
    </b-row>

    <b-row class="d-flex align-items-start">
      <b-col class="col-12 col-md-2">
        <input-select-search
          :label="$t('ACADEMICO.PERIODO_LETIVO')"
          required
          ref="periodoLetivo"
          :options="opcoes.anoLetivo"
          v-model="form.anoLetivoId"
        />
      </b-col>

      <b-col class="col-12 col-md-2">
        <input-select-search
          :label="$t('ACADEMICO.CURSOS')"
          required
          ref="curso"
          :options="opcoes.cursos"
          v-model="form.cursoId"
          :isDisabled="desabilitar.curso"
        />
      </b-col>

      <b-col class="col-12 col-md-2">
        <input-select-search
          :label="$t('ACADEMICO.TURMAS')"
          :options="opcoes.turmas"
          v-model="form.turmaId"
          :isDisabled="desabilitar.turma"
        />
      </b-col>

      <b-col cols="12" md="auto">
        <b-button
          variant="primary"
          @click="abrirSelecaoTipo"
          class="botao-acao-filtro w-100 my-2"
        >
          {{ $t('GERAL.PROCESSAR') }}
        </b-button>
      </b-col>

      <b-col cols="12" md="auto">
        <b-button
          variant="secondary"
          @click="limparFiltros"
          class="botao-acao-filtro w-100 my-2"
        >
          {{ $t('GERAL.LIMPAR_FILTRO') }}
        </b-button>
      </b-col>
    </b-row>

    <tabela
      :items="itemsFiltro"
      @historico="obtemHistorico"
      @alterar-ordenacao="novaOrdenacao"
    />

    <paginacao
      :total="total"
      v-model="paginacao"
      @input="getMatriculas"
    />

    <modal-historico
      :exibir="modais.historico"
      :aluno="modais.historicoDados"
      @fechar="closeModal('historico')"
    />

    <b-modal
      id="modal-tipo-documento"
      v-model="modais.tipoDocumento"
      :title="$t('ACADEMICO.SELECIONE_TIPO_DOCUMENTO')"
      :ok-title="$t('GERAL.IMPRIMIR')"
      :cancel-title="$t('GERAL.CANCELAR')"
      @ok="confirmarProcessamento"
    >
      <input-select-search
        :label="$t('ACADEMICO.TIPO_DOCUMENTO')"
        :options="opcoesTipoDocumento"
        v-model="form.tipoDocumento"
      />
    </b-modal>
  </div>
</template>

<script>
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';
import modais from '@/common/utils/modais';
import pdf from '@/common/utils/pdf';

import MatriculaService from '@/common/services/matriculas/matriculas.service';
import CurriculoEscolarService from '@/common/services/curriculo-escolar/curriculo-escolar.service';
import HistoricoEscolarService from '@/common/services/academico/historicoEscolar.service';

import AnoLetivoService from '@/common/services/anoLetivo/ano-letivo.service';
import CursoService from '@/common/services/academico/curso.service';
import TurmasService from '@/common/services/academico/turma.service';

import Tabela from './components/TabelaMatricula';
import ModalHistorico from './components/Modal';
import Paginacao from '@/components/paginacao/Paginacao';
import TituloHistoricoEscolar from '@/views/academico/outras-instituicoes/historico-escolar/components/TituloHistoricoEscolar';
import InputText from '@/components/inputs/InputText.vue';
import { InputSelectSearch } from '@/components/inputs';

export default {
  name: 'HistoricoEscolar',
  components: {
    TituloHistoricoEscolar,
    InputText,
    Tabela,
    ModalHistorico,
    Paginacao,
    InputSelectSearch,
  },
  data() {
    return {
      items: [],
      nome: '',
      itemsFiltro: [],
      total: 0,
      opcoes: {
        anoLetivo: [],
        cursos: [],
        turmas: [],
      },
      form: {
        anoLetivoId: '',
        cursoId: '',
        turmaId: '',
        tipoDocumento: null,
      },
      opcoesTipoDocumento: [
        { text: 'Histórico escolar', value: 'historico' },
        { text: 'Certificado de conclusão', value: 'certificado' },
      ],
      desabilitar: {
        turma: true,
        curso: true,
      },
      modais: {
        historico: false,
        historicoDados: {},
        tipoDocumento: false,
      },
      paginacao: { numeroDaPagina: 1, tamanhoDaPagina: 10 },
      campoOrdenado: null,
      ordem: false,
    };
  },
  mounted() {
    this.getAnosLetivos();
    this.pesquisar();
  },
  watch: {
    'form.anoLetivoId'(anoLetivoId) {
      if (anoLetivoId) {
        this.getCursos(anoLetivoId);
      } else {
        this.opcoes.cursos = [];
        this.opcoes.turmas = [];
        this.desabilitar.curso = true;
        this.desabilitar.turma = true;
      }
      this.form.cursoId = null;
      this.form.turmaId = null;
    },
    'form.cursoId'(cursoId) {
      if (cursoId) {
        this.selecaoCurso(cursoId);
      } else {
        this.opcoes.turmas = [];
        this.desabilitar.turma = true;
      }
      this.form.turmaId = null;
    },
  },
  methods: {
    limpar() {
      this.nome = null;
      this.pesquisar();
    },
    limparFiltros() {
      this.form = {
        anoLetivoId: '',
        cursoId: '',
        turmaId: '',
        tipoDocumento: null,
      };

      if (this.$refs.periodoLetivo) this.$refs.periodoLetivo.clearAll();
      if (this.$refs.curso) this.$refs.curso.clearAll();

      this.opcoes.cursos = [];
      this.opcoes.turmas = [];
      this.desabilitar.curso = true;
      this.desabilitar.turma = true;

      this.pesquisar();
    },
    pesquisar() {
      this.paginacao = {
        numeroDaPagina: 1,
        tamanhoDaPagina: 10,
      };
      this.getMatriculas();
    },
    getMatriculas() {
      this.$store.dispatch(START_LOADING);
      MatriculaService.listarAlunos(
        this.paginacao,
        this.campoOrdenado,
        this.ordem,
        this.nome
      )
        .then(({ data }) => {
          const itens = data.itens || [];
          this.items = itens;

          this.itemsFiltro = itens.filter((x) => {
            const anoOk = !this.form.anoLetivoId || x.anoLetivoId === this.form.anoLetivoId;
            const cursoOk = !this.form.cursoId || x.cursoId === this.form.cursoId;
            const turmaOk = !this.form.turmaId || x.turmaId === this.form.turmaId;
            return anoOk && cursoOk && turmaOk;
          });

          this.total = data.paginacao.totalDeElementos;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    abrirSelecaoTipo() {
      if (!this.form.anoLetivoId || !this.form.cursoId || !this.form.turmaId) {
        mensagem.warning(
          this.$t('GERAL.AVISO'),
          this.$t('Preencha Ano Letivo, Curso e Turma para processar.')
        );
        return;
      }
      this.modais.tipoDocumento = true;
    },
    async confirmarProcessamento(bvModalEvt) {
      if (!this.form.tipoDocumento) {
        bvModalEvt.preventDefault();
        mensagem.warning(
          this.$t('GERAL.AVISO'),
          this.$t('Selecione o tipo de documento que deseja processar.')
        );
        return;
      }

      if (this.form.tipoDocumento === 'historico') {
        await this.processarHistorico();
      } else if (this.form.tipoDocumento === 'certificado') {
        await this.processarCertificado();
      }

      this.form.tipoDocumento = null;
    },
    async processarHistorico() {
      try {
        this.$store.dispatch(START_LOADING);

        const payload = {
          ...this.form,
          layoutHistoricoEscolar: 1,
        };

        const { data } = await HistoricoEscolarService.imprimirHistoricoEmLote(payload);

        if (data && data.documento) {
          const bytes = pdf.base64ToArrayBuffer(data.documento);
          const blob = new Blob([bytes], { type: 'application/pdf' });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = data.nomeArquivo;
          link.click();
        }
      } catch (error) {
        mensagem.showErrors(error);
      } finally {
        this.$store.dispatch(STOP_LOADING);
      }
    },
    async processarCertificado() {
      try {
        this.$store.dispatch(START_LOADING);

        const payload = {
          ...this.form,
          layoutHistoricoEscolar: 2,
        };

        const { data } = await HistoricoEscolarService.imprimirHistoricoEmLote(payload);

        if (data && data.documento) {
          const bytes = pdf.base64ToArrayBuffer(data.documento);
          const blob = new Blob([bytes], { type: 'application/pdf' });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = data.nomeArquivo;
          link.click();
        }
      } catch (error) {
        mensagem.showErrors(error);
      } finally {
        this.$store.dispatch(STOP_LOADING);
      }
    },
    obtemHistorico(key, item) {
      this.$store.dispatch(START_LOADING);
      CurriculoEscolarService.obterPorMatriculaId(item.id)
        .then(({ data }) => {
          this.modais.historicoDados = data;
          this.openModal(key, item);
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    openModal(key, item) {
      return modais.abrirModal(this, key, item);
    },
    closeModal(key) {
      return modais.fecharModal(this, key);
    },
    novaOrdenacao(campoOrdenado, ordem) {
      this.campoOrdenado = campoOrdenado;
      this.ordem = !ordem;
      this.getMatriculas();
    },
    getAnosLetivos() {
      this.$store.dispatch(START_LOADING);
      AnoLetivoService.listar()
        .then(({ data }) => {
          const lista = data.map((row) => ({
            ...row,
            text: row.ano,
            value: row.id,
          }));
          this.opcoes.anoLetivo = lista;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    getCursos(anoLetivoId) {
      this.$store.dispatch(START_LOADING);
      CursoService.obterPorAnoLetivo(anoLetivoId)
        .then(({ data }) => {
          const lista = data.map((row) => ({
            ...row,
            text: row.descricao,
            value: row.id,
          }));

          if (lista.length === 0) {
            this.opcoes.cursos = [
              {
                text: this.$t('ACADEMICO.SEM_CURSOS'),
                value: undefined,
              },
            ];
          } else {
            this.opcoes.cursos = lista;
          }

          this.desabilitar.curso = false;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    getTurmas(cursoId) {
      if (cursoId !== '') {
        this.$store.dispatch(START_LOADING);
        TurmasService.buscarPorCursoAnoLetivo(this.form)
          .then(({ data }) => {
            const lista = data.map((row) => ({
              ...row,
              text: row.descricao,
              value: row.id,
            }));
            this.opcoes.turmas = lista;
            this.desabilitar.turma = false;
          })
          .catch((err) => {
            mensagem.showErrors(err);
          })
          .finally(() => {
            this.$store.dispatch(STOP_LOADING);
          });
      }
    },
    selecaoCurso(cursoId) {
      this.form.turmaId = '';
      this.getTurmas(cursoId);
    },
  },
};
</script>
